import {inject, Injectable} from '@angular/core';
import {Functions, httpsCallable, HttpsCallableResult} from "@angular/fire/functions";
import {from, map, Observable} from "rxjs";

export interface ChatMessage {
  author: 'user' | 'bot';
  text: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private functions: Functions = inject(Functions);

  sendMessage(query: string): Observable<{ answer: string }> {
    const askAI = httpsCallable(this.functions, 'askAnalyticsAI');

    // Use .pipe() and map() to correctly transform the result
    return from(askAI({ query })).pipe(
      map((result: HttpsCallableResult) => result.data as { answer: string })
    );
  }
}
